<template>
    <main id="dashboard">
        <div class="container mx-auto">
            <div class="breadcumb">
                <div class="breadcumb__left">
                    <p class="breadcumb__title">Dashboard</p>
                </div>
                <div class="breadcumb__right">
                    <date-picker prefix-class="xmx" v-model="value" type="date" range placeholder="Select date range"></date-picker>
                </div>
            </div>

            <h2 class="title">Transaction</h2>

            <div class="flex flex-wrap items-stretch -mx-3">
                <!-- CHART -->
                <div class="px-3 w-full pb-6 lg:pb-0 lg:w-1/2">
                    <div class="card h-full">
                        <canvas id="overviewChart"></canvas>
                    </div>
                </div>
                
                <!-- OVERVIEW -->
                <div class="px-3 w-full lg:w-1/2">

                    <div class="flex flex-wrap h-full -mx-3">
                        <div class="px-3 pb-6 w-full sm:w-1/2">
                            <div class="card card--overview h-full">
                                <h3 class="card--overview__val">0</h3>
                                <div class="card--overview__label">
                                    <i class="fa fa-shopping-cart"></i>
                                    <span>Total Orders</span>
                                </div>
                            </div>
                        </div>
                        <div class="px-3 pb-6 w-full sm:w-1/2">
                            <div class="card card--overview h-full">
                                <h3 class="card--overview__val">0</h3>
                                <div class="card--overview__label">
                                    <i class="fa fa-credit-card"></i>
                                    <span>Total Paid</span>
                                </div>
                            </div>
                        </div>
                        <div class="px-3 pb-6 sm:pb-0 w-full sm:w-1/2">
                            <div class="card card--overview h-full">
                                <h3 class="card--overview__val">0%</h3>
                                <div class="card--overview__label">
                                    <i class="fa fa-percentage"></i>
                                    <span>Paid Ratio</span>
                                </div>
                            </div>
                        </div>
                        <div class="px-3 pb-6 sm:pb-0 w-full sm:w-1/2">
                            <div class="card card--overview h-full">
                                <h3 class="card--overview__val">0</h3>
                                <div class="card--overview__label">
                                    <i class="fa fa-shopping-cart"></i>
                                    <span>Unpaid Orders</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </main>
</template>

<script>
    import Chart from 'chart.js';
    import DatePicker from 'vue2-datepicker';
    export default {
        components: { DatePicker },
        data() {
            return {
            value: [new Date(2020, 11, 1), new Date(2020, 11, 7)],
            };
        },
        mounted () {
            var barChartData = {
                labels: [
                    "26/12/2018",
                    "27/12/2018",
                    "28/12/2018",
                    "29/12/2018",
                    "30/12/2018",
                    "31/12/2018",
                    "1/1/2019",
                    "2/1/2019"
                ],
                datasets: [
                    {
                    label: "Transaksi",
                    backgroundColor: "#23A455",
                    borderColor: "#23A455",
                    borderWidth: 1,
                    data: [5, 3, 3, 11, 23, 4, 9, 5],
                    },
                    {
                    label: "Order",
                    backgroundColor: "#FFE072",
                    borderColor: "#FFE072",
                    borderWidth: 1,
                    data: [8, 4, 2, 6, 21, 3, 21, 6]
                    }
                ]
                };

                var chartOptions = {
                responsive: true,
                legend: {
                    position: "top",
                    labels: {
                    boxWidth: 18,
                    boxHeight:18,
                    radius: 20,
                    fontColor: '#404040'
                    }
                },
                title: {
                    display: false,
                    text: ""
                },
                scales: {
                    yAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        color: "#E2F4FF",
                        zeroLineWidth:1,
                        zeroLineColor:"#ADADAD"
                    }
                    }],
                    xAxes: [{
                    barPercentage: 0.4,
                    gridLines: {
                        display:false,
                    }
                    }]
                }
                }

                window.onload = function() {
                var ctx = document.getElementById("overviewChart").getContext("2d");
                window.myBar = new Chart(ctx, {
                    type: "bar",
                    data: barChartData,
                    options: chartOptions
                });
            };
        }
    }
</script>

<style lang="sass" scoped>
</style>